<!-- Loading bar -->
<loading-bar></loading-bar>

<!-- Navigation -->
<vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container verticalNavigationHeader>
        <ng-content select="[asideHeader]"></ng-content>
    </ng-container>

    <!-- Navigation content header hook -->
    <ng-container verticalNavigationContentHeader>
        <ng-content select="[asideContentHeader]"></ng-content>
    </ng-container>
    
    <!-- Navigation footer hook -->
    <ng-container verticalNavigationFooter>
        <ng-content select="[asideFooter]"></ng-content>
    </ng-container>
</vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0"
>

    <header></header>

    <!-- Content -->
    <div class="px-4 md:px-6">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!-- <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">LHackSRT &copy; {{currentYear}}</span>
    </div> -->

</div>
